module.exports = __webpack_public_path__ + "static/media/common-reasons-why-app-store-rejects-apps-how-to-avoid-them.ca37a86e.svg";